// extracted by mini-css-extract-plugin
module.exports = {"container":"aF-z","fullWidth":"bF-z","item":"cF-z","priceContainer":"dF-z","msrp":"eF-z","price":"fF-z","discount":"gF-z"};